import { StorageService } from './services/flowOrchestrationService/StorageService'

const getStorageKey = (
	applicantId: string,
	applicantSessionId: string,
	consentType: 'customClient' | 'flow',
) => {
	return `${applicantId}:${applicantSessionId}::${consentType}`
}

class UserConsentManager {
	#applicantId: string | undefined
	#applicantSessionId: string | undefined
	#storage: StorageService

	constructor() {
		this.#storage = new StorageService()
	}

	public setApplicantData(applicantId: string, applicantSessionId: string) {
		this.#applicantId = applicantId
		this.#applicantSessionId = applicantSessionId
	}

	public setConsent(consentType: 'customClient' | 'flow') {
		if (this.#applicantId == null || this.#applicantSessionId == null) {
			return
		}
		this.#storage.set(
			getStorageKey(this.#applicantId, this.#applicantSessionId, consentType),
			'given',
		)
	}

	public hasGivenConsent(consentType: 'customClient' | 'flow') {
		if (this.#applicantId == null || this.#applicantSessionId == null) {
			return false
		}

		return (
			this.#storage.get(
				getStorageKey(this.#applicantId, this.#applicantSessionId, consentType),
			) === 'given'
		)
	}

	public clear() {
		if (this.#applicantId != null && this.#applicantSessionId != null) {
			this.#storage.remove(
				getStorageKey(
					this.#applicantId,
					this.#applicantSessionId,
					'customClient',
				),
			)
			this.#storage.remove(
				getStorageKey(this.#applicantId, this.#applicantSessionId, 'flow'),
			)
			this.#applicantId = undefined
			this.#applicantSessionId = undefined
		}
	}
}

export const userConsentManager = new UserConsentManager()
